import React from "react";

const BootstrapLoader = () => {
  return (
    <div className="absolute inset-0 bg-black bg-opacity-5 flex items-center justify-center z-50 rounded-xl">
      <div className="h-10 w-10 border-4 border-gray-300 border-t-black rounded-full animate-spin"></div>
    </div>
  );
};

export default BootstrapLoader;
